import {
  Component,
  effect,
  inject,
  input,
  InputSignal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { ICorporateDesign, IMask, ISubscriptionTicket } from '@web/dtos';
import { ReactiveFormsModule } from '@angular/forms';
import { LoadingAnimationComponent } from '../../../../components/feedback/loading-animation/loading-animation.component';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { EPage } from '../../../../components/feedback/direct-ticket-configuration-shopping-cart/direct-ticket-configuration-shopping-cart.component';
import { SubscriptionConfigStore } from '../../../../services/api/subscription/subscription-config-store.service';
import { SubscriptionTicketsStore } from '../../../../services/api/subscription/subscription-store.service';
import { SubscriptionTicketShoppingCart } from '../../../../components/feedback/subscription-ticket-shopping-cart/subscription-ticket-shopping-cart';
import { ERoute } from '../../../../constants/routes.enum';
import { ProgressTrackerSupportService } from '../../../../services/support/progress-tracker-support/progress-tracker-support.service';
import { ActiveSubscriptionTicketsStore } from '../../../../services/api/subscription/active-subscriptions/active-subscriptions-store.service';

@Component({
  selector: 'aw-subscription-option-configuration-page',
  imports: [
    ReactiveFormsModule,
    LoadingAnimationComponent,
    RouterOutlet,
    SubscriptionTicketShoppingCart,
  ],
  templateUrl: './subscription-option-configuration-page.component.html',
})
export class SubscriptionOptionConfigurationPage {
  public readonly ticketName: InputSignal<string> = input.required();

  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly subscriptionTicketsStore: ActiveSubscriptionTicketsStore =
    inject(ActiveSubscriptionTicketsStore);
  protected readonly subscriptionConfigStore: SubscriptionConfigStore = inject(
    SubscriptionConfigStore
  );
  protected readonly progressTracker: ProgressTrackerSupportService = inject(
    ProgressTrackerSupportService
  );

  protected readonly EPage: typeof EPage = EPage;

  public readonly corporateDesign: Signal<ICorporateDesign> =
    this.corporateDesignService.corporateDesign;
  public readonly isLoading: Signal<boolean> =
    this.subscriptionConfigStore.isLoading;

  protected currentStep: WritableSignal<number> =
    this.progressTracker.currentStep;
  constructor() {
    this.progressTracker.currentStep.set(0);
    effect(() => {
      const subscription: ISubscriptionTicket | undefined =
        this.subscriptionTicketsStore
          .subscriptions()
          .find(subscriptionTicket => {
            return subscriptionTicket.name === this.ticketName();
          });
      if (subscription) {
        this.subscriptionConfigStore.loadSubscriptionConfiguration(
          subscription.guid
        );
      } else {
        console.warn('Unable to match subscription');
        this.router.navigate(['/subscription-tickets']);
      }
    });
  }

  proceedToNextStep() {
    const baseMasks: IMask[] = this.subscriptionConfigStore.baseMasks() ?? [];
    if (baseMasks) {
      const maxStep: number = baseMasks.length;
      const newStep: number = this.currentStep() + 1;
      if (newStep === maxStep) {
        this.router
          .navigate(['../', this.ticketName(), ERoute.payment], {
            relativeTo: this.route,
            queryParamsHandling: 'preserve',
          })
          .then(r => this.currentStep.set(newStep));
      } else if (newStep < maxStep) {
        this.router
          .navigate(['../', this.ticketName(), ERoute.mask, newStep], {
            relativeTo: this.route,
            queryParamsHandling: 'preserve',
          })
          .then(r => this.currentStep.set(newStep));
      }
    }
  }
}
